import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-filter-by-field',
  templateUrl: './filter-by-field.component.html',
  styleUrls: ['./filter-by-field.component.scss']
})
export class FilterByFieldComponent {

  @Input() items: any[];
  @Input() textField: string = 'name';
  @Input() valueField: string = 'name';

  @Output() itemSelect: EventEmitter<string>;

  public itemSelected: any;

  constructor(private library: FaIconLibrary) {
    this.items = [];
    this.library.addIcons(faTimes);
    this.itemSelect = new EventEmitter<string>()
  }

  public setSelectedItem(dataItem: any) {
    const value = dataItem[this.valueField];
    this.itemSelected = dataItem;
    this.itemSelect.emit(value);
  }

  public setUnselectedItem(event) {
    this.itemSelected = null;
    this.itemSelect.emit(null);
    event.stopPropagation();
  }
}
